import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'menuDetail',
  props: ['route', 'allRoutes'],
  computed: {
    routes: function routes() {
      return this.route.children;
    }
  },
  methods: {
    getQuery: function getQuery(data) {
      var str = '';

      if (data !== undefined) {
        for (var st in data.query) {
          if (str === '') {
            str += st + '=' + data.query[st];
          } else {
            str += '&' + st + '=' + data.query[st];
          }
        }
      }

      return str;
    },
    hasOneShowingChildren: function hasOneShowingChildren(children) {
      // 是否直接显示只有一个子菜单的对象
      var showingChildren = children.filter(function (item) {
        return !item.hidden;
      });

      if (showingChildren.length === 1) {
        return true;
      }

      return false;
    },
    chooseRouters: function chooseRouters(router) {
      // 修改选中的左侧菜单
      // console.log(this.route)
      // var r = []
      // this.allRoutes.forEach(item => {
      //     if (item.isShow === 1) {
      //         r.push(item)
      //     }
      // })
      // console.log(r)
      // var allRoute = {
      //     children: r,
      //     componentType: 'layout',
      //     name: '0',
      //     path: '/main',
      //     isShow: 1,
      //     meta: {
      //         title: '目录'
      //     },
      //     isShowMenu: false
      // }
      this.$emit('hiddenProver', this.route);
      this.$store.dispatch('ChooseRouters', this.route).then(function () {}).catch(function () {
        console.log('修改左侧菜单失败！');
      });
    }
  }
};